/* eslint-disable class-methods-use-this */
import cn from 'classnames'
import React from 'react'
import { DateRangePicker } from 'react-dates'
import 'react-dates/initialize'

import { withStyles } from '@material-ui/core/styles'
import isSameDay from 'react-dates/src/utils/isSameDay'

import 'react-dates/lib/css/_datepicker.css'

import Icon from '../Icon'
import LabelWrapper from '../LabelWrapper'
// import { START_DATE, END_DATE, HORIZONTAL_ORIENTATION, ANCHOR_LEFT } from 'react-dates/constants';
import DatePickerWrapper from './DatePickStyle'
import './react_dates_overrides.css'

const styles = () => ({
  'under-line': {
    backgroundColor: '#008489 !important',
  },
})

class DatePicker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      startDate: this.props.startDate || null,
      endDate: this.props.endDate || null,
      focused: false,
    }
  }

  onDateChange = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate })
    this.props.onDateChange({ startDate, endDate })
  }

  getYears = (startYear, endYear) => {
    const currentYear = new Date().getFullYear()
    const years = []
    const startYears = startYear || 1900
    const endYears = endYear || currentYear + 10
    let i
    for (i = startYears; i <= endYears; i += 1) {
      years.push(i.toString())
    }
    return years
  }

  render() {
    const {
      placeholder,
      allowMargin,
      smallView,
      blockedDates,
      hightLightDates,
      actionLink,
      className,
      customCol,
      customMargin,
      customPadding,
      customWidth,
      disabled,
      errorText,
      fullWidth,
      helperText,
      id,
      isLabelInline,
      isRequired,
      isToolTip,
      justify,
      label,
      multipleFields,
      noMobile,
      notWrapper,
      noWrap,
      openDirection,
      showActionLink,
      showInPopup,
      spacing,
      toolTipIcon,
      toolTipIconColor,
      toolTipIconSize,
      toolTipPosition,
      toolTipText,
      verticalSpacing,
      withBorder,
      withDivider,
      ...rest
    } = this.props
    return (
      <LabelWrapper
        actionLink={actionLink}
        className={cn({ withBorder }, 'date-picker', className)}
        customCol={customCol}
        customMargin={customMargin}
        customPadding={customPadding}
        customWidth={customWidth}
        disabled={disabled}
        errorText={errorText}
        fullWidth={fullWidth}
        helperText={helperText}
        id={id}
        isLabelInline={isLabelInline}
        isRequired={isRequired}
        isToolTip={isToolTip}
        justify={justify}
        label={label}
        multipleFields={multipleFields}
        noMobile={noMobile}
        notWrapper={notWrapper}
        noWrap={noWrap}
        showActionLink={showActionLink}
        spacing={spacing}
        toolTipIcon={toolTipIcon}
        toolTipIconColor={toolTipIconColor}
        toolTipIconSize={toolTipIconSize}
        toolTipPosition={toolTipPosition}
        toolTipText={toolTipText}
        withBorder={withBorder}
        withDivider={withDivider}
      >
        <DatePickerWrapper className={cn({ disabled, errorText }, `open_${openDirection}`)}>
          <DateRangePicker
            displayFormat="DD MMM YYYY"
            startDate={this.state.startDate}
            startDateId="your_unique_start_date_id"
            endDate={this.state.endDate}
            endDateId="your_unique_end_date_id"
            onDatesChange={this.onDateChange}
            focusedInput={this.state.focusedInput}
            onFocusChange={focusedInput => this.setState({ focusedInput })}
            isDayBlocked={day1 => blockedDates.some(day2 => isSameDay(day1, day2))}
            isDayHighlighted={day1 => hightLightDates.some(day2 => isSameDay(day1, day2))}
            noBorder={!withBorder}
            readOnly
            numberOfMonths={smallView ? 1 : 2}
            placeholder={placeholder}
            hideKeyboardShortcutsPanel
            style={customWidth ? { width: `${customWidth}px` } : {}}
            navPrev={
              <Icon
                className="DayPickerNavigation_leftButton__horizontalDefault DayPickerNavigation_button__default DayPickerNavigation_button__horizontalDefault"
                iconSize={25}
                iconName="chevron-left"
                color="grey"
                style={{ backgroundColor: '#FFF' }}
              />
            }
            navNext={
              <Icon
                className="DayPickerNavigation_rightButton__horizontalDefault DayPickerNavigation_button__default DayPickerNavigation_button__horizontalDefault"
                iconSize={25}
                iconName="chevron-right"
                color="grey"
                style={{ backgroundColor: '#FFF' }}
              />
            }
            disabled={disabled}
            verticalSpacing={verticalSpacing}
            openDirection={openDirection}
            appendToBody={!showInPopup}
            withPortal={showInPopup}
            {...rest}
          />
          <div
            style={{
              marginBottom: allowMargin && this.state.focused ? 365 : 0,
            }}
          />
        </DatePickerWrapper>
      </LabelWrapper>
    )
  }
}

DatePicker.defaultProps = {
  onDateChange: () => {},
  openDirection: 'down',
  placeholder: '',
  allowMargin: false,
  smallView: false,
  fullWidth: false,
  showInPopup: false,
  verticalSpacing: 0,
  notWrapper: true,
}

export default withStyles(styles)(DatePicker)
